/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Pause_Reasons_Team_CountInputs */

const en_tables_pause_reasons_team_count = /** @type {(inputs: Tables_Pause_Reasons_Team_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reasons Team Count`)
};

const de_tables_pause_reasons_team_count = /** @type {(inputs: Tables_Pause_Reasons_Team_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Teams`)
};

/**
* | output |
* | --- |
* | "Reasons Team Count" |
*
* @param {Tables_Pause_Reasons_Team_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_pause_reasons_team_count = /** @type {((inputs?: Tables_Pause_Reasons_Team_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Pause_Reasons_Team_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_pause_reasons_team_count(inputs)
	return de_tables_pause_reasons_team_count(inputs)
});